export const LEASE_FILTER = {
  TYPES: {
    BETWEEN: 'between',
    LESS: 'less',
    MORE: 'more',
    DEFAULT: 'default',
  },
};

export const OFFERS = {
  TYPES: {
    FINANCE: 'Finance',
    LEASE: 'Lease',
    SPECIAL: 'Special',
    HCPV: 'HCPV',
  },
};

export const SORT_OPTIONS = [
  'bestapr',
  'bestlease',
];

export const SORT_OPTION_TYPES = {
  bestapr: 'Finance',
  bestlease: 'Lease',
};

export const ALL_VEHICLES_FLAG = 'ModelGroupName';
export const TYPE_FLAG = 'SalesProgramType';
export const ALL_VEHICLES_FLAG_VALUE = 'All Vehicles';

export const DATE_FORMAT = {
  EXPIRATION: 'MM/DD/YY',
  DETAIL_RANGE: 'MMMM D, YYYY',
};
